import { render, staticRenderFns } from "./reportShipment.vue?vue&type=template&id=89a5feca&scoped=true&"
import script from "./reportShipment.vue?vue&type=script&lang=js&"
export * from "./reportShipment.vue?vue&type=script&lang=js&"
import style0 from "./reportShipment.vue?vue&type=style&index=0&id=89a5feca&scoped=true&lang=less&"
import style1 from "./reportShipment.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a5feca",
  null
  
)

export default component.exports